import React from 'react'

export default (props) => (
    <img
        className={props.className}
        src={`${window.location.origin}/content/logos/color-bug`}
        alt='vertalo'
    />
)
